module.exports = __webpack_public_path__ + "img/user-premium.00705d97.svg";